import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DescriptionIcon from '@mui/icons-material/Description';
import DownloadIcon from '@mui/icons-material/Download';
import { useGetCarrierParams } from 'feature/dispatching/hooks';
import { downloadFile } from '../../utils';

const DocumentListItem = ({ trailerId, title, type }) => {
  const { carrier } = useGetCarrierParams();
  return (
    <ListItem
      secondaryAction={
        trailerId && (
          <IconButton edge="end" onClick={() => downloadFile(trailerId, type, carrier)}>
            <DownloadIcon color="primary" />
          </IconButton>
        )
      }
      sx={{ py: 2 }}
    >
      <ListItemIcon sx={{ minWidth: 32 }}>
        <DescriptionIcon />
      </ListItemIcon>
      <ListItemText
        primary={title}
        slotProps={{
          primary: { noWrap: true },
        }}
      />
    </ListItem>
  );
};

DocumentListItem.propTypes = {
  title: PropTypes.oneOf(['Wet Test', 'Method27']).isRequired,
  trailerId: PropTypes.string,
  type: PropTypes.oneOf(['WT', 'M27']).isRequired,
};
DocumentListItem.defaultProps = {
  trailerId: null,
};
export default DocumentListItem;
